<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>
            {{ source.title }}
            <open-on-site
              :source-route="source.route"
            />
            <button class="btn btn-danger btn-sm" @click="$_deleteEntity(`topics/${source.id}`)">
              Delete
              <span ref="deleteBtnLoader" class="btn-loader" style="display: none;" />
            </button>
          </h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Body *</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured.section_id" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured.section_id && entity.featured.section_id > 0" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featured.featured_body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        :already-choosen-refs="entity.loadedReferences"
        @changeRefs="$_changeRefs"
      />

      <terms
        :already-choosen-terms="entity.terms"
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button
          class="btn btn-success"
          @click="saveEntity"
        >
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Data saved successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

export default {
  name: 'TopicEdit',

  components: {
    referencer: Referencer,
    terms: Terms,
    'open-on-site': OpenOnSiteButton,
  },

  mixins: [EditPageMixin, CommonPageMixin],

  methods: {
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}topics/${this.$route.params.id}`, {
        params: {
          with: ['references', 'terms', 'path_alias', 'featured'],
        },
      }).then((response) => {
        this.source = this.$_apadtSource(response.data);
        this.entity = _.cloneDeep(this.source);
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting topic request' });
        console.error('Error in get single topic query', error);
      });
    },
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' },
        { name: 'Body', value: this.entity.body, type: 'required' },
      ]);
    },
    saveEntityRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.body) postFormData.append('body', this.entity.body);
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}topics/${this.$route.params.id}`, postFormData);
    },
    saveEntity() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveEntityRequest().then(() => {
        this.$_successSave();
      }, (error) => {
        console.error('Error in topic update migration', error);
        this.$_errorSave(error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?87c4c488